import { render, staticRenderFns } from "./company-licence-information.vue?vue&type=template&id=acf64232&"
import script from "./company-licence-information.vue?vue&type=script&lang=js&"
export * from "./company-licence-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports